/**
 * Visual treatment of the field. `outlined` (default) is a tinted surface
 * with a clear border, used in standalone forms and chip menus. `naked`
 * strips the chrome, used inside dense list rows for inline rename so the
 * input visually replaces the static text without a layout shift. `pill`
 * is a fully-rounded, borderless field used inside modal dialogs — the
 * surface tone deepens on focus instead of growing a border ring.
 */
export const TEXT_FIELD_APPEARANCE_OUTLINED = 'outlined';
export const TEXT_FIELD_APPEARANCE_NAKED = 'naked';
export const TEXT_FIELD_APPEARANCE_PILL = 'pill';

export type TextFieldAppearance =
  | typeof TEXT_FIELD_APPEARANCE_OUTLINED
  | typeof TEXT_FIELD_APPEARANCE_NAKED
  | typeof TEXT_FIELD_APPEARANCE_PILL;

export const TEXT_FIELD_SIZE_SM = 'sm';
export const TEXT_FIELD_SIZE_MD = 'md';
export const TEXT_FIELD_SIZE_LG = 'lg';

export type TextFieldSize =
  | typeof TEXT_FIELD_SIZE_SM
  | typeof TEXT_FIELD_SIZE_MD
  | typeof TEXT_FIELD_SIZE_LG;

/**
 * Per-size pill height + horizontal padding + label font size. `sm` (28px)
 * matches `Button` size `sm` so the two line up in dense toolbars; `md`
 * (32px) matches the standard chip-menu / form-row height; `lg` (52px) is
 * the airy modal-dialog field used with `appearance="pill"`.
 */
export const TEXT_FIELD_SIZE_TOKENS: Record<
  TextFieldSize,
  { height: string; padX: string; fontSize: string; iconSize: string }
> = {
  [TEXT_FIELD_SIZE_SM]: {
    height: '28px',
    padX: '10px',
    fontSize: '12.5px',
    iconSize: '16px',
  },
  [TEXT_FIELD_SIZE_MD]: {
    height: '32px',
    padX: '12px',
    fontSize: '13px',
    iconSize: '18px',
  },
  [TEXT_FIELD_SIZE_LG]: {
    height: '52px',
    padX: '20px',
    fontSize: '14px',
    iconSize: '20px',
  },
};
